module.exports = __webpack_public_path__ + "img/lengthwise-splash.544cde85.jpg";